const styles = {
  pageHolder: {
    paddingBottom: '80px'
  },
  head: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}

export default styles
